import { useEffect } from "react";

function useOnClickOutside(ref, handler, ignoreClassName) {
  useEffect(() => {
    const listener = (e) => {
      if (ignoreClassName && e.target.classList.contains(ignoreClassName))
        return;
      if (!ref.current || ref.current.contains(e.target)) return;

      handler(e);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

export default useOnClickOutside;
